import _ from 'lodash';
import * as actions from '~/actions/agents';

const defaultState = {
  agentsByTeamId: {},
};

const agentState = (state = defaultState, action) => {
  switch (action.type) {
    case actions.UPDATE_AGENTS: {
      const newAgentsByTeamId = _.cloneDeep(state.agentsByTeamId);

      newAgentsByTeamId[action.teamId] = action.agents;
      return Object.assign({}, state, {
        agentsByTeamId: newAgentsByTeamId,
      });
    }
    default:
      return state;
  }
};

export default agentState;
